// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"057dabab","650":"e6520481","787":"598500a1"}[chunkId] + ".chunk.js";
};